import { useState } from 'react';
import {
  IconButton,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
} from '@mui/material';

import { NomenclatureGroupFine, ListResponse } from '@/types';
import { Pagination } from '@/components';
import { EditFlat, TrashFlat } from '@/assets/icons';
import theme from '@/theme';

import { DeleteNomenclatureGroupFine, UpdateNomenclatureGroupFine } from '../components';

export interface NomenclatureGroupFineListProps {
  list?: ListResponse<NomenclatureGroupFine>;
  page: number;
  onChangePage(page: number): void;
}

const NomenclatureGroupFinesTable: React.FC<NomenclatureGroupFineListProps> = ({ list, page, onChangePage }) => {
  const [updateModalOpened, setOpenedUpdateModal] = useState(false);
  const [deleteModalOpened, setOpenedDeleteModal] = useState(false);
  const [currentNomenclatureGroupFine, setCurrentNomenclatureGroupFine] = useState<NomenclatureGroupFine | null>(null);

  function openUpdateModal(nomenclatureGroupFine: NomenclatureGroupFine) {
    setCurrentNomenclatureGroupFine(nomenclatureGroupFine);
    setOpenedUpdateModal(true);
  }

  function openDeleteModal(nomenclatureGroupFine: NomenclatureGroupFine) {
    setCurrentNomenclatureGroupFine(nomenclatureGroupFine);
    setOpenedDeleteModal(true);
  }

  return (
    <>
      <Stack spacing={3}>
        <TableContainer component={Paper} sx={{ maxHeight: `calc(100vh - ${theme.spacing(34.5)})` }}>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell>Общая пени (&lt;= 30)</TableCell>
                <TableCell>Общая пени (&gt;= 30)</TableCell>
                <TableCell>Точка</TableCell>

                <TableCell />
              </TableRow>
            </TableHead>

            <TableBody>
              {list?.data.map((nomenclatureGroupFine) => {
                const { lt_30_days, gt_30_days, point, id } = nomenclatureGroupFine;

                return (
                  <TableRow key={id}>
                    <TableCell>{lt_30_days}</TableCell>
                    <TableCell>{gt_30_days}</TableCell>
                    <TableCell>{point?.name ?? '—'}</TableCell>

                    <TableCell>
                      <Stack direction="row" spacing={1}>
                        <Tooltip title="Обновить">
                          <IconButton aria-label="Обновить" onClick={() => openUpdateModal(nomenclatureGroupFine)}>
                            <EditFlat sx={{ fontSize: 16 }} />
                          </IconButton>
                        </Tooltip>

                        <Tooltip title="Удалить">
                          <IconButton aria-label="Удалить" onClick={() => openDeleteModal(nomenclatureGroupFine)}>
                            <TrashFlat sx={{ fontSize: 16 }} />
                          </IconButton>
                        </Tooltip>
                      </Stack>
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>

        <Pagination
          size="medium"
          count={list?.meta.last_page}
          page={page}
          boundaryCount={2}
          color="primary"
          shape="rounded"
          onChange={(event, value) => onChangePage(value)}
        />
      </Stack>

      <UpdateNomenclatureGroupFine
        nomenclatureGroupFine={currentNomenclatureGroupFine!}
        open={updateModalOpened}
        onClose={() => setOpenedUpdateModal(false)}
      />
      <DeleteNomenclatureGroupFine
        nomenclatureGroupFine={currentNomenclatureGroupFine!}
        open={deleteModalOpened}
        onClose={() => setOpenedDeleteModal(false)}
      />
    </>
  );
};

export default NomenclatureGroupFinesTable;
